export default {
    "name": "HomePurchaseOrderDefaults",
    "kind": "HoudiniQuery",
    "hash": "931754aba6d124ee03f023e1dbb1a4419bbea35363630a9c478b165b05305f41",

    "raw": `query HomePurchaseOrderDefaults {
  settingValues {
    home {
      defaultPurchaseOrderHistoryDateRange
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "home": {
                            "type": "HomeSettingValues",
                            "keyRaw": "home",

                            "selection": {
                                "fields": {
                                    "defaultPurchaseOrderHistoryDateRange": {
                                        "type": "String",
                                        "keyRaw": "defaultPurchaseOrderHistoryDateRange",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=35e0be0e2bcb4006094eeaa3460fcb9ed3a0565dccd78ebb1a110624ca7aae8a";